"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//Il faut un composant ou un control avec un ref du nom de done
exports.default = {
    props: ["index", "readonly", "prefixIt"],
    methods: {
        getClass: function getClass(classBase, conditionalClass) {
            return "" + classBase + (this.index > 0 ? " " + conditionalClass : "");
        },
        getPrefixedName: function getPrefixedName(itemName) {
            return this.prefixIt + "." + this.index + (itemName ? "." + itemName : "");
        },
        getSuffixedName: function getSuffixedName(itemName) {
            return itemName + "." + this.index;
        }
    },
    mounted: function mounted() {
        if (this.$refs.done && this.$refs.done.value) {
            this.readonly = true;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/Mixins/ControlIteration.ts
// module id = 130
// module chunks = 0